import {IRouteFn, TRecordKey, TRedirect, TRouteData, TSection} from '../types';
import qs from 'qs';
import {PRIVATE_ROUTE_BASE_TO_URL} from 'core/modules/routing/constants';

interface IRouteConverterParams {
    section?: TSection;
    urls: IRouteFn;
    redirect: TRedirect;
}

interface IPathFactoryParams {
    base: string;
    id?: string | number;
    slug?: string[];
}

export const pathFactory = ({base, id, slug}: IPathFactoryParams) => {
    if (!id) {
        return `${base}/`;
    }

    if (!slug) {
        return `${base}/${id}`;
    }

    return `${base}/${id}/${slug.join('/')}`;
};

export const urlToRouteConverter = <T extends TRecordKey>({
    section,
    urls,
    redirect,
}: IRouteConverterParams): TRouteData<T> =>
    Object.keys(urls).reduce(
        (stack, page) => ({
            ...stack,
            [page]: {
                route: page,
                section,
                to: redirect(urls[page]),
                url: urls[page],
            },
        }),
        {} as TRouteData<T>,
    );

export const withQueryParams = (path: string, params: Record<string, any>): string => {
    const p = params;

    return Object.keys(p).length ? `${path}?${qs.stringify(p)}` : path;
};

export const parseUrlQueryString = (url: string, queryKey: string) =>
    new URLSearchParams(`?${url.split('?').pop()}`).get(queryKey);

export const isPersonalPages = (pathname: string, baseUrl = PRIVATE_ROUTE_BASE_TO_URL): boolean => {
    if (pathname === baseUrl) {
        return true;
    }

    return pathname.startsWith(`${baseUrl}/`);
};
